import { createAsyncAction } from 'typesafe-actions';
import { CallQueue } from '../../types/CallQueue';

export const getCallQueues = createAsyncAction(
    'GET_CALL_QUEUES',
    'GET_CALL_QUEUES_SUCCESS',
    'GET_CALL_QUEUES_FAILED',
)<undefined, CallQueue[], undefined>();
